export default __webpack_public_path__ + "static/media/Barbees.c2e2e9c1.JPG";